import MotifHistoire from '@/views/consultations/cloture/motif-histoire';
import ExamenClinique from '@/views/consultations/cloture/examen-clinique';
import HypotheseDiagnostic from '@/views/consultations/cloture/hypothese-diagnostic';
import HypotheseDiagnosticCpn from '@/views/consultations/cloture/hypotheses-diagnostic-cpn';
import ExamenBio from '@/views/consultations/cloture/examen-bio';
import ExamenParaHistorique from '@/views/consultations/cloture/examen_para_historique';
import ConduiteAtenir from '@/views/consultations/cloture/conduite-a-tenir';
import OrdonnanceMedicale from '@/views/consultations/cloture/ordonnance-medicale';
import SectionGrossesse from '@/views/consultations/cloture/section-grossesse';
import ExamensPhysiques from '@/views/consultations/cloture/examens-physiques';
import RendezVousSuivant from '@/views/consultations/cloture/rendez-vous-suivant';
import FacteurPonderation from '@/views/consultations/cloture/facteurs-pondérations';
import Plaintes from '@/views/consultations/cloture/plaintes'
import Constantes from '@/views/consultations/cloture/constantes'
import TraitementEnCoursHistorique from '@/views/consultations/cloture/traitement-en-cours-historique'

// ATCD
import ATCDHistoriqueNeonatologie from '@/views/consultations/cloture/atcd-historique-neonatologie'
import ATCDHistoriqueENFpersonnel from '@/views/consultations/cloture/atcd-historique-enf-personnel'
import ATCDHistoriqueENFfamiliaux from '@/views/consultations/cloture/atcd-historique-enf-familiaux'
import ATCDHistoriqueAllergoPersonnel from '@/views/consultations/cloture/atcd-historique-allergologie-personnel'
import ATCDHistoriqueAllergoFamiliaux from '@/views/consultations/cloture/atcd-historique-allergologie-familiaux'
import ATCDHistoriqueAllergoEnvironnement from '@/views/consultations/cloture/atcd-historique-allergologie-environnement-vie'
import ATCDHistoriqueAdultePersonnel from '@/views/consultations/cloture/atcd-historique-adulte-personnel'
import ATCDHistoriqueAdulteFamiliaux from '@/views/consultations/cloture/atcd-historique-adulte-familiaux'

import AnamneseHistorique from '@/views/consultations/cloture/anamnese-historique'

import ConsultationCommentaire from '@/views/consultations/cloture/consultation-commentaire'

import EnteteBonEtFacture from '@/views/en-tete-bon-facture'
import Vue from 'vue'
import VueHtml2pdf from 'vue-html2pdf'
Vue.use(VueHtml2pdf)

export default {
    name: 'cloture',
    components: {
        ExamenBio, MotifHistoire, OrdonnanceMedicale,
        ExamenClinique, ConduiteAtenir, HypotheseDiagnostic,
        HypotheseDiagnosticCpn, SectionGrossesse, ExamensPhysiques,
        RendezVousSuivant, FacteurPonderation, Plaintes,
        ExamenParaHistorique, ATCDHistoriqueNeonatologie, 
        ATCDHistoriqueENFpersonnel, ATCDHistoriqueENFfamiliaux, 
        ATCDHistoriqueAllergoPersonnel, ATCDHistoriqueAllergoFamiliaux, ATCDHistoriqueAllergoEnvironnement,
        ATCDHistoriqueAdultePersonnel, ATCDHistoriqueAdulteFamiliaux, AnamneseHistorique, Constantes,
        TraitementEnCoursHistorique, EnteteBonEtFacture, VueHtml2pdf,
        ConsultationCommentaire
    },
    props: ['consultation', 'consultation_id'],
    data() {
        return {
            prescription_loading: true,
            examenbio_loading: true,

            exam_is_empty: true,
            exam_is_loading: true,

            is_printing: false,
            filename: '',
        }
    },
    computed: {
        demande_analyses() {
            return this.$store.getters["demandesAnalysesHistorique"];
        },

        demande_examen_para() {
			return this.$store.getters["examen_para_historique"]
		},

        liste_prescription() {
            return this.$store.getters["consultationOrdonnance"];
        },

        user_role() {
            return this.$store.getters['activeRole'].nom;
        },

        /**
         * User Active role
         * @returns 
         */
        activeRole() {
            return this.$store.getters['activeRole'];
        },

        champs_exm_clinique_historique() {
            return this.$store.getters["champs_exm_clinique_historique"];
        },

    },
    mounted() {
        var d = new Date()
        var tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()

        this.filename = 'Historique_de_consultation_'+tmpstamp

        this.$store.dispatch("getDemandeAnalyses", { id: this.consultation.id, enCours: false }).then(() => {
            this.examenbio_loading = false
        })

        this.$store.dispatch('getDemandeExamen', { consultation_id: this.consultation.id, enCours: false }).then(() => {
			this.exam_is_loading = false

			if (this.demande_examen_para.length == 0) {
				this.exam_is_empty = true
			} else {
				this.exam_is_empty = false
			}
		})

        this.$store.dispatch('getConsultationOrdonnance', { id: this.consultation.id, enCours: false }).then(() => {
            this.prescription_loading = false
        })

        if (this.user_role == 'ROLE_SAGE_FEMME') {
            this.$store.dispatch('getGrossesseEnCours', { consultation_id: this.consultation.id });
            this.$store.dispatch('getExamensPhysiquesEnCours', { consultation_id: this.consultation.id });
        }


        this.$store.dispatch("getChampExamClinique", 
            { 
                data_type: 'examen_clinique', consultation_id: this.consultation.id, 
                en_cours: false, type_consultation_id: this.consultation.tarif_consultation.type_consultation.id
            }
        ).then(async() => {
            if (this.champs_exm_clinique_historique.length > 0) {
                this.additional_empty = false
            } else {
                this.additional_empty = true
            }

            this.$emit("emitHistoriqueConsultation", this.champs_exm_clinique_historique, this.consultation)
        })

        console.log("INFO PATIENT: ",this.consultation)

    },

    methods: {
        backToListHistorique() {
            this.$emit("emitBackToListHistorique")
        },

        printHistorique() {
            this.is_printing = true

            this.$refs.html2Pdf.generatePdf()
        },

        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf().set(options).from(pdfContent).set(
                {
                    margin: [0.5, 0, 1.5, 0], 
                    pageBreak: { mode: 'css', before:'#nextpage1'},
                }
            ).toPdf().get('pdf').then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages()
                // let foot_1 = 'SAGBADO AGOTIME. LOME- TOGO 18 BP 254 TEL : (+228)  70 68 85 85 /96 43 47 47'
                // let foot_2 = 'cliniqueephata@gmail.com   NIF :  10001794727'

                
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i)

                    // pdf.setFont('Arial', 'B', 8)
                    // pdf.setFontSize(10)
                    // pdf.text(foot_1, (pdf.internal.pageSize.getWidth() * 0.18), (pdf.internal.pageSize.getHeight() - 0.8))
                    // pdf.text(foot_2, (pdf.internal.pageSize.getWidth() * 0.32), (pdf.internal.pageSize.getHeight() - 0.6))

                    pdf.setFontSize(10)
                    pdf.text('Page ' + i + ' sur ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
                } 
            }).save().then(() => {
                this.is_printing = false;
            })
        },

        hasDownloaded() {},

        onProgress() { },

        startPagination() {},

        hasPaginated() {}
    }
}